import dayjs from "dayjs";
import { toCapitalizeFirstLetterOfEachWord } from "../../../consumingApi/services/helper";

// A consulta aceita exatamente um filtro por vez (mais de um => 400 na API)
export const FILTER_OPTIONS = [
  { value: "tracking_code", label: "Tracking code" },
  { value: "delivery_id", label: "ID da delivery" },
  { value: "barcode", label: "Código de barras" },
  { value: "polo", label: "Polo" },
];

export const FILTER_PLACEHOLDERS = {
  tracking_code: "Digite o tracking code",
  delivery_id: "Digite o ID da delivery",
  barcode: "Digite o código de barras",
};

// Status finais: a API rejeita o cancelamento (422)
export const FINAL_STATUSES = [
  "ENTREGUE",
  "CANCELADA",
  "DEVOLVIDA_AO_PONTO_DE_COLETA",
  "DEVOLVIDA_PUDO",
];

export const isFinalStatus = (status) => FINAL_STATUSES.includes(status);

export const PATHWAY_TYPE_LABELS = {
  COLETA: "Coleta",
  MIDDLE_MILE: "Middle mile",
  ENTREGA: "Entrega",
  DEVOLUCAO: "Devolução",
};

const SUCCESS_STATUSES = ["ENTREGUE", "CONCLUIDA", "CONCLUIDO"];
const ERROR_STATUSES = ["CANCELADA", "CANCELADO", "DEVOLVIDA_AO_PONTO_DE_COLETA", "DEVOLVIDA_PUDO"];

export const getStatusTagType = (status) => {
  if (SUCCESS_STATUSES.includes(status)) return "success";
  if (ERROR_STATUSES.includes(status)) return "error";
  return "info";
};

export const formatEnumLabel = (value) =>
  value ? toCapitalizeFirstLetterOfEachWord(String(value).replace(/_/g, " ")) : "-";

export const formatDate = (value) => (value ? dayjs(value).format("DD/MM/YYYY") : "-");

export const formatDateTime = (value) =>
  value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "-";

const FILE_TYPE_IMAGE = "IMAGE";

export const getImageFiles = (evidence) =>
  (evidence?.files || []).filter((file) => file.file_type === FILE_TYPE_IMAGE);

// Todos os hashes de imagem das evidências das paradas, sem repetir
export const getImageHashes = (delivery) => {
  if (!delivery) return [];
  const evidencias = (delivery.pathways || []).flatMap((p) =>
    (p.stops || []).flatMap((stop) => stop.evidences || [])
  );
  return [
    ...new Set(
      evidencias.flatMap((e) => getImageFiles(e).map((file) => file.file_hash)).filter(Boolean)
    ),
  ];
};
